export default __webpack_public_path__ + "static/media/pettycash.41878711.png";